import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EditIcon, TrashIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
interface StockThreshold {
  id: string;
  productName: string;
  productCode: string;
  warehouse: string;
  minStockLevel: number;
  reorderPoint: number;
  reorderQuantity: number;
  alertChannels: string[];
  status: 'Active' | 'Inactive';
}
const mockThresholds: StockThreshold[] = [{
  id: '1',
  productName: 'Laptop Dell XPS 15',
  productCode: 'PROD-001',
  warehouse: 'Main Warehouse',
  minStockLevel: 10,
  reorderPoint: 15,
  reorderQuantity: 20,
  alertChannels: ['Email', 'In App'],
  status: 'Active'
}, {
  id: '2',
  productName: 'Office Chair Ergonomic',
  productCode: 'PROD-002',
  warehouse: 'Main Warehouse',
  minStockLevel: 5,
  reorderPoint: 8,
  reorderQuantity: 10,
  alertChannels: ['Email', 'SMS'],
  status: 'Active'
}, {
  id: '3',
  productName: 'Printer HP LaserJet',
  productCode: 'PROD-003',
  warehouse: 'Regional Warehouse',
  minStockLevel: 3,
  reorderPoint: 5,
  reorderQuantity: 8,
  alertChannels: ['Email', 'In App', 'SMS'],
  status: 'Active'
}, {
  id: '4',
  productName: 'Whiteboard Markers',
  productCode: 'PROD-004',
  warehouse: 'Main Warehouse',
  minStockLevel: 50,
  reorderPoint: 75,
  reorderQuantity: 100,
  alertChannels: ['Email'],
  status: 'Active'
}, {
  id: '5',
  productName: 'USB Flash Drive 32GB',
  productCode: 'PROD-005',
  warehouse: 'Regional Warehouse',
  minStockLevel: 20,
  reorderPoint: 30,
  reorderQuantity: 50,
  alertChannels: ['In App'],
  status: 'Inactive'
}];
export function StockThresholdList() {
  const navigate = useNavigate();
  const handleDelete = (id: string) => {
    if (window.confirm('Are you sure you want to delete this threshold?')) {
      alert('Threshold deleted successfully!');
    }
  };
  const columns: Column<StockThreshold>[] = [{
    key: 'productCode',
    label: 'Product Code',
    render: item => <span className="font-medium text-indigo-600" data-id="element-2579">{item.productCode}</span>
  }, {
    key: 'productName',
    label: 'Product Name',
    render: item => <span className="font-medium text-gray-900" data-id="element-2580">{item.productName}</span>
  }, {
    key: 'warehouse',
    label: 'Warehouse'
  }, {
    key: 'minStockLevel',
    label: 'Min Stock'
  }, {
    key: 'reorderPoint',
    label: 'Reorder Point'
  }, {
    key: 'reorderQuantity',
    label: 'Reorder Qty'
  }, {
    key: 'alertChannels',
    label: 'Alert Channels',
    render: item => <div className="flex flex-wrap gap-1" data-id="element-2581">
          {item.alertChannels.map(channel => <span key={channel} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800" data-id="element-2582">
              {channel}
            </span>)}
        </div>
  }, {
    key: 'status',
    label: 'Status',
    render: item => <StatusBadge status={item.status} data-id="element-2583" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-2584">
      <div className="flex items-center justify-between" data-id="element-2585">
        <div data-id="element-2586">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2587">Stock Thresholds</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-2588">
            Manage stock levels, reorder points, and alert configurations.
          </p>
        </div>
        <button onClick={() => navigate('/stock-thresholds/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-2589">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-2590" />
          New Threshold
        </button>
      </div>

      <div className="flex-1" data-id="element-2591">
        <DataTable columns={columns} data={mockThresholds} keyExtractor={item => item.id} searchPlaceholder="Search thresholds..." onRowClick={item => navigate(`/stock-thresholds/${item.id}/edit`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-2593">
              <button onClick={() => navigate(`/stock-thresholds/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" data-id="element-2594">
                <EditIcon className="h-4 w-4" data-id="element-2595" />
              </button>
              <button onClick={() => handleDelete(item.id)} className="text-red-600 hover:text-red-900" data-id="element-2596">
                <TrashIcon className="h-4 w-4" data-id="element-2597" />
              </button>
            </div>} data-id="element-2592" />
      </div>
    </div>;
}